import React from "react";
import { useTranslation } from "react-i18next";

/* Re-usable legal-trader block. Reads localized strings with English defaults
   so the block renders correctly in every language even before translation. */

export default function LegalNotice({ compact = false, testid = "legal-notice" }) {
  const { t } = useTranslation();
  return (
    <div
      className={`rounded-2xl border border-ink-100 bg-ink-50/60 ${compact ? "p-3" : "p-4"} text-[11px] leading-relaxed text-ink-700`}
      data-testid={testid}
    >
      <div className="font-semibold text-ink-900 text-xs mb-1">BlueRoam Ltd</div>
      <p>
        {t(
          "legal.trader",
          "BLUEROAM LTD, a private company limited by shares incorporated in England and Wales (company number 17215030), whose registered office is at 128 City Road, London, United Kingdom, EC1V 2NX.",
        )}
      </p>
      <div className="mt-1 text-ink-500">
        🇬🇧 {t("legal.country", "Country of incorporation: United Kingdom")} ·{" "}
        <a href="mailto:hello@blueroam.io" className="hover:text-cobalt-600 underline">hello@blueroam.io</a>
      </div>
    </div>
  );
}
